<template>
    <div>
        <div class="card border-0 shadow-sm text-center" v-if="pool != null">
            <div class="card-body p-0">
                <div class="col-md-12 py-3 border-bottom">
                    <h6 class="m-0 p-0 font-weight-bold text-center">{{ pool.name }}</h6>
                </div>
                <div class="row py-3 px-2 no-gutters">
                    <div class="col-md-4 text-center">
                        <p class="mb-2">
                            <progress-circle 
                                :completed-steps=amountContributed.chartCount
                                :total-steps=count
                                :diameter=130
                                circle-color="#eee"
                                start-color="#32cd32"
                                stop-color="#32cd32"
                                :circle-width=6
                                :animation-duration=1000
                                inner-display="slot"
                            >
                            <p class="m-0 h6">{{ amountContributed.percentage}}% </p>

                            </progress-circle>
                        </p>
                        <p class="mb-4 mb-lg-2 h6">
                            <span class="h6 font-weight-bold" style="color: #32cd32;">&#8358;{{ pool.contributed_amount | moneyformat }} </span> received of <strong class=""> &#8358;{{ pool.total_amount | moneyformat }}</strong>
                        </p>
                    </div>

                    <div class="col-md-4 ">
                        <p class="mb-2">
                            <progress-circle 
                                :completed-steps=amountContributed.chartCount
                                :total-steps=count
                                :diameter=130
                                circle-color="#eee"
                                start-color="#32cd32"
                                stop-color="#32cd32"
                                :circle-width=6
                                :animation-duration=1000
                                inner-display="slot"
                            >
                            <p class="m-0 h6">{{ amountContributed.percentage}}% </p>

                            </progress-circle>
                        </p>
                        <p class="mb-4 mb-lg-2 h6">{{ pool.contributions }} out of {{ pool.member_count }} contributions</p>
                    </div>
                    <div class="col-md-4 ">
                        <p class="mb-2">
                            <progress-circle 
                                :completed-steps=5 
                                :total-steps=count
                                :diameter=130
                                circle-color="#eee"
                                start-color="#32cd32"
                                stop-color="#32cd32"
                                :circle-width=6
                                :animation-duration=1000
                                inner-display="slot"
                            >
                            <p class="m-0 h6">50% </p>

                            </progress-circle>
                        </p>
                        <p class="mb-4 mb-lg-2 h6">{{ pool.contribution_deadline | diffFromNow }} to go</p>
                    </div>

                </div>
            </div>
        </div>

        <!-- <div class="card border-0 shadow-sm text-center" v-else>
            <div class="card-body p-0">

                <div class="row py-3 px-2 no-gutters">
                    <div class="col-md-4 text-center">
                        <p class="mb-1">
                            <progress-circle 
                                :completed-steps=0
                                :total-steps=count
                                :diameter=130
                                circle-color="#eee"
                                start-color="#32cd32"
                                stop-color="#32cd32"
                                :circle-width=6
                                :animation-duration=1000
                                inner-display="slot"
                            >
                            <p class="m-0 h6">0% </p>

                            </progress-circle>
                        </p>
                        <p class="mb-4 mb-lg-2 h6">
                            <span class="h6 font-weight-bold" style="color: #32cd32;">&#8358;xxx </span> received of <strong class=""> &#8358;xxx</strong>
                        </p>
                    </div>

                    <div class="col-md-4 ">
                        <p class="mb-1">
                            <progress-circle 
                                :completed-steps=0
                                :total-steps=count
                                :diameter=130
                                circle-color="#eee"
                                start-color="#32cd32"
                                stop-color="#32cd32"
                                :circle-width=6
                                :animation-duration=1000
                                inner-display="slot"
                            >
                            <p class="m-0 h6">0% </p>

                            </progress-circle>
                        </p>
                        <p class="mb-4 mb-lg-2 h6">x out of y contributions</p>
                    </div>
                    <div class="col-md-4 ">
                        <p class="mb-1">
                            <progress-circle 
                                :completed-steps=0 
                                :total-steps=count
                                :diameter=130
                                circle-color="#eee"
                                start-color="#32cd32"
                                stop-color="#32cd32"
                                :circle-width=6
                                :animation-duration=1000
                                inner-display="slot"
                            >
                            <p class="m-0 h6">0% </p>

                            </progress-circle>
                        </p>
                        <p class="mb-4 mb-lg-2 h6">xxx days to go</p>
                    </div>

                </div>
            </div>
        </div> -->
        
    </div>
</template>

<script>
import { ProgressCircle } from 'vue-progress-circle';

export default {
    name: 'PoolProgress',
    props: ['pool'],

    data() {
        return {
            count: 10
        }
    },
    components: {
        ProgressCircle
    },
    computed: {
        amountContributed() {
            const { contributions, member_count } = this.pool;

            const result = (contributions / member_count) * 100;
            const chart = result/10;

            return {
                percentage: parseInt(result),
                chartCount: parseInt(chart)
            }
        },
    }
}
</script>

<style>

</style>